// extracted by mini-css-extract-plugin
export default {"container":"style_container__pgjf3","text":"style_text__QxB-c"};